import React from 'react';
import styles from './MobileDetailsSheet.module.css';
import {ReplaceIcon} from './EditorIcons';
import {CloseIcon} from '../marketing/icons/Icons';

// Mobile-only "Page details" sheet, opened from the tasks sheet / app bar
// More menu. Same fields as the desktop side panel's Page details section.
const MobileDetailsSheet = ({open, title, onTitleChange, backgroundThumbnail, onReplaceBackground, onClose}) => {
    if (!open) return null;

    return (
        <div className={styles.scrim} onClick={onClose}>
            <section
                role="dialog"
                aria-modal="true"
                aria-labelledby="mobile-details-title"
                className={styles.sheet}
                onClick={(e) => e.stopPropagation()}
            >
                <div className={styles.dragHandleRow}><span className={styles.dragHandle}/></div>
                <header className={styles.header}>
                    <h2 id="mobile-details-title" className={styles.title}>Page details</h2>
                    <button type="button" aria-label="Close" className={styles.closeButton} onClick={onClose}>
                        <CloseIcon width={18} height={18}/>
                    </button>
                </header>
                <div className={styles.body}>
                    <div className={styles.field}>
                        <label htmlFor="mobile-details-name" className={styles.fieldLabel}>Name</label>
                        <input
                            id="mobile-details-name"
                            type="text"
                            value={title || ''}
                            onChange={onTitleChange}
                            className={styles.nameInput}
                        />
                    </div>
                    <div className={styles.field}>
                        <span className={styles.fieldLabel}>Background</span>
                        <div className={styles.thumbWell}>
                            {backgroundThumbnail && <img src={backgroundThumbnail} alt="" className={styles.thumbImg}/>}
                        </div>
                        <button type="button" className={styles.replaceButton} onClick={onReplaceBackground}>
                            <ReplaceIcon/>Replace background
                        </button>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default MobileDetailsSheet;
